/* eslint-disable react/self-closing-comp */
/* eslint-disable jsx-a11y/control-has-associated-label,jsx-a11y/interactive-supports-focus,jsx-a11y/no-static-element-interactions,react/no-danger */
import { ChangeEvent, FC, useCallback, useState, KeyboardEvent, useRef, useEffect } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import moment from 'moment';
import cn from 'classnames';
import { Props } from './types';
import { translationDataState, useRecoilValue } from '../../../../../store';

const Chat: FC<Props & { children?: any }> = (props) => {
  const { chatOpen, messages = [], onSubmit, toggleChatClick, currentUserId } = props;
  const [message, setMessage] = useState<string>('');
  const messagesEndRef = useRef(null);
  const { typeHere = 'Type Here', chat = 'Chat' } = useRecoilValue(translationDataState) || {};

  const handleMessageChange = useCallback((e: ChangeEvent<HTMLInputElement>) => {
    setMessage(e.target.value);
  }, []);

  const handleMessageSubmit = useCallback(
    (e: KeyboardEvent<HTMLInputElement>) => {
      if (e.keyCode !== 13 || !message) return;
      onSubmit(e, message);
      setMessage('');
    },
    [message, onSubmit],
  );
  const handleSendMessage = useCallback(
    (e) => {
      onSubmit(e, message);
      setMessage('');
    },
    [message, onSubmit],
  );

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages]);

  return (
    <div className={chatOpen ? 'chat open' : 'chat'}>
      <i className="fas fa-times" onClick={toggleChatClick} />
      <h3>{chat}</h3>
      <div className="messages">
        {messages.map((item: any, index: number) => {
          return (
            <div
              key={`${item.from}_${moment(item.timestamp).format('HH:mm:ss')}_${index}`}
              className={cn('messge-wrap', currentUserId === item.from && 'own-message')}
            >
              <img src={item.avatarImage || '/images/face_1.png'} alt="user_image" />
              <span key={item.timestamp} className="message">
                {currentUserId !== item.from && (
                  <i className="name">
                    <span className="name-itself">{item.name}</span>{' '}
                    <span className="ml-3">{moment(item.timestamp).format('HH:mm')}</span>
                  </i>
                )}
                <i
                  className="content"
                  dangerouslySetInnerHTML={{
                    __html: item.text?.replace(
                      /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/gim,
                      (f: any) => `<a href="${f}" target="_blank">${f}</a>`,
                    ),
                  }}
                />
                {currentUserId === item.from && (
                  <i className="name">
                    <span>{moment(item.timestamp).format('HH:mm')}</span>
                  </i>
                )}
              </span>
            </div>
          );
        })}
        <div ref={messagesEndRef}></div>
      </div>
      <div className="send">
        <img src="/images/chat_send_g3.png" alt="send_icon" onClick={handleSendMessage} />
        <input
          type="text"
          onChange={handleMessageChange}
          value={message}
          placeholder={typeHere}
          onKeyDown={handleMessageSubmit}
        />
      </div>
    </div>
  );
};

export default Chat;
